<template>
    <rkm-overlay>
        <rkm-layout-body title="Relatório de exames solicitados por status">
            <template v-slot:actions>
                <rkm-button
                    @click.stop="handleExit"
                    color="danger"
                >
                    Sair
                </rkm-button>
            </template>
            <rkm-layout-content v-if="loaded">
                <List
                    :data="{ initials, form, model, additionals }"
                    ref="List"
                />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
import List from '@/components/exame-laboratorial/exame-solicitado-status/List'

import { mapActions } from 'vuex'
import { repository, error, object, data } from '@/mixins'

export default {
    components: { List },
    created() {

        this.repositories = {
            exame: this.getConectaSusRepository('exameLaboratorial.exameSolicitadoStatus')
        }

        this.load()
    },
    data: () => ({
        loaded: false,
        initials: {
            model: {}
        },
        form: {},
        model: {},
        additionals: {},
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            this.setLoading()

            this.repositories.exame.list()
                .then(({ data }) => {

                    data.form.periodo.start = this.getDateObject(data.form.periodo.start)
                    data.form.periodo.end = this.getDateObject(data.form.periodo.end)

                    this.initials.model = Object.freeze(this.clone(data.model))

                    this.form = data.form
                    this.model = data.model
                    this.additionals = data.additionals

                    this.loaded = true
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleExit() {

            this.redirectToList()
        },
        redirectToList() {

            this.$router.push({ name: 'dashboard' })
        }
    },
    mixins: [repository, error, object, data]
}
</script>